export const EV_RANGE_LEADERBOARD_CONTENT_PATH = 'research/infographics/ev-range-consumption-conditions';
export const EV_RANGE_LEADERBOARD_HOSTING_PAGE = '/car-news/electric-car-range-and-consumption-epa-vs-edmunds.html';
